import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["type", "placeholder", "value", "readonly", "disabled"]

import { computed, PropType } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReusableInput',
  props: {
  modelValue: {
    type: [String, Number, null] as PropType<string | number | null>,
    default: null,
  },
  label: { type: String },
  type: { type: String, default: 'text' },
  readonly: { type: Boolean, default: false },
  typeStyle: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  v: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;
const typeInput = computed(() => {
  return props.type === 'password' ? 'password' : 'text';
})
const classes = computed(() => {
  switch (props.typeStyle) {
    case "product":
      return {
        name: "product",
        row: "row",
        label: "col-sm-3 col-form-label",
        input: "col-sm-9",
      };
      break;
    default:
      return { name: "profile", row: "", label: "form-label", input: "" };
      break;
  }
});
const isNumber = (event) => {
  if (props.type == "price") {
    const keyCode = event.keyCode ? event.keyCode : event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      event.preventDefault();
    }
  }
  if (props.type == "number") {
    const keyCode = event.keyCode ? event.keyCode : event.which;
    if ((keyCode < 48 || keyCode > 57)) {
      event.preventDefault();
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('mb-2 ' + classes.value.row)
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("b", {
          key: 0,
          for: "name",
          class: _normalizeClass(classes.value.label)
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(classes.value.input)
    }, [
      _createElementVNode("input", _mergeProps({
        type: typeInput.value,
        placeholder: __props.label,
        autocomplete: "off",
        class: "form-control"
      }, _ctx.$attrs, {
        value: __props.modelValue,
        readonly: props?.readonly,
        disabled: props.disabled,
        onKeypress: _cache[0] || (_cache[0] = ($event: any) => (isNumber($event))),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }), null, 16, _hoisted_1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "text-danger",
          key: error.$uid
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ], 2)
  ], 2))
}
}

})